import { _js } from '@ifixit/utils/localize';
import headerTemplate from 'ejs/embed/embed.v4.header.ejs';
import logoTemplate from 'ejs/embed/embed.v4.ifixit_logo.ejs';
import escape from 'lodash/escape';
import Template from 'Shared/template';

export function PrepareEmbed(template) {
   return function (data) {
      data = augmentData(data);

      let element = $(template(data));

      // Add target="_parent" to all links in the embed
      element.find('a:not(.no-blank)').attr('target', '_blank');

      element
         .find('.js-nav-button')
         .attr('title', _js('Hint: You can use left/right arrow keys to navigate the guide!'));

      let siteName = $('html').data('site');

      if (siteName != 'ifixit') {
         element.find('.js-hide-ifixit').remove();
      }

      return element;
   };
}

function augmentData(data) {
   // Add some defaults to the data object
   data = {
      pageTitle: null,
      ifixitLogo: null,
      dozukiLogo: null,
      ...data,
   };

   const headerT = Template.get(headerTemplate);
   const compiledHeader = headerT(data, /* asString */ true);

   const logoT = Template.get(logoTemplate);
   const compiledLogo = logoT(data, /* asString */ true);

   return {
      ...data,
      compiledHeader: compiledHeader,
      compiledLogo: compiledLogo,
      imgSrcSet: imgSrcSet,
   };
}

/**
 * Note: This is an analog to the ViewUtils.php function imgSrcSet()
 * Returns html of a sizes=.. and srcset=.. attribute for creating responsive
 * images.
 *
 * image: object with sizename:url key-value mappings for each size available
 *       The api returns this object for nearly every image.
 * viewSize: Best guess about the width this image will be displayed at.
 *            default is the width of the viewport "100vw", can also accept
 *            pixel sizes and media queries to give the browser a hint as to
 *            how big the image will be at different browser widths.
 * maxSize: size name of the maximum size that should be included. IF you know
 *           this image won't be shown bigger than 200px, you can prevent
 *           inclusion of large and huge sizes to save on html.
 */
function imgSrcSet(image, viewSize, maxSize) {
   maxSize = maxSize || 'large';

   const sizesAttr = viewSize ? `sizes="${escape(viewSize)}"` : 'sizes="100vw"';

   const sizes = [];

   const sizeWidths = App.imageSizeWidths;
   // Cause a mini is quite small and it isn't worth only showing a mini
   delete sizeWidths.mini;

   Object.keys(sizeWidths).forEach(sizeName => {
      if (sizeWidths[sizeName] <= sizeWidths[maxSize] && (!image || image[sizeName])) {
         sizes.push(escape(image[sizeName]) + ' ' + sizeWidths[sizeName] + 'w');
      }
   });

   if (!sizes.length) {
      return null;
   }

   /**
    * iOS 8 Safari only reads the first srcset URL if the unit is width (w)
    * based. Flip to default to largest image.
    */
   sizes.reverse();

   return `${sizesAttr} srcset="${sizes.join(', ')}"`;
}
